(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkout-direct-navigation"] && !Shopify.designMode) return;
  try {
    (function () {
		if (window.__aivelaCheckoutNavigationBound) return;
		window.__aivelaCheckoutNavigationBound = true;
		var pending = null;
		function ready() {
			if (window.themeCore && window.themeCore.Checkout) return Promise.resolve(window.themeCore.Checkout);
			return new Promise(function (resolve, reject) {
				var timeout = setTimeout(function () {
					document.removeEventListener('theme:cart:ready', loaded);
					reject(new Error('Unable to confirm your cart. Please refresh and try again.'));
				}, 8000);
				function loaded() {
					if (!window.themeCore || !window.themeCore.Checkout) return;
					clearTimeout(timeout);
					document.removeEventListener('theme:cart:ready', loaded);
					resolve(window.themeCore.Checkout);
				}
				document.addEventListener('theme:cart:ready', loaded);
			});
		}
		function request(event, button, form) {
			event.preventDefault(); event.stopImmediatePropagation(); event.stopPropagation();
			if (pending) return;
			pending = ready().then(function (checkout) {
				return checkout.request({ button: button, form: form });
			}).catch(function (error) {
				// Initialized checkout owns its status, including the server-accepted quantity.
				if (window.themeCore && window.themeCore.Checkout) return;
				document.querySelectorAll('[data-cart-operation-status]').forEach(function (element) {
					element.hidden = false;
					var message = element.querySelector('[data-cart-operation-message]');
					if (message) message.textContent = error.description || error.message;
				});
			}).finally(function () { pending = null; });
		}
		document.addEventListener('click', function (event) {
			var button = event.target.closest && event.target.closest('[name="checkout"]');
			if (button && !button.disabled) request(event, button, button.form);
		}, true);
		document.addEventListener('submit', function (event) {
			var form = event.target, button = event.submitter;
			if (button && button.name === 'checkout' || !button && form.matches('form[id^="cart-"]')) request(event, button, form);
		}, true);
	})();
  } catch(e) { console.error(e); }
})();

})();
